export const selectListUserManagementUsers = (state) =>
  state.userManagement.listUser?.users ?? null;

export const selectListTenantUsers = (state) =>
  state.userManagement?.listTenantUser ?? null;

export const selectListUserManagementOrganizations = (state) =>
  state.userManagement?.listOrganization;
